export default "__VITE_ASSET__DALreuyW__"